var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StringUtils } from '../../utils';
export var EmptyState = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, props = __rest(_a, ["size"]);
    return (_jsxs("div", __assign({ className: StringUtils.combineStrings(['localina-empty-state', size, props.extraClassName]) }, { children: [_jsx("div", __assign({ className: "localina-empty-state__icon", "aria-hidden": true }, { children: props.icon })), _jsx("h2", __assign({ className: "localina-empty-state__title" }, { children: props.title })), props.text && _jsx("p", __assign({ className: "localina-empty-state__text" }, { children: props.text })), props.action && _jsx("div", __assign({ className: "localina-empty-state__action" }, { children: props.action })), props.children] })));
};
